import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { useLoading } from '../contexts/LoadingContext';
import LoadingButton from '../components/LoadingButton';
import BrandMark from '../components/BrandMark';
import { Eye, EyeOff } from 'lucide-react';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const { showSuccess, showError } = useToast();
  const { isLoading, withLoading } = useLoading();
  const navigate = useNavigate();

  const handleSubmit = withLoading('login', async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(email, password);
      showSuccess('Connexion', 'Bon retour.');
      navigate('/library');
    } catch (error: any) {
      showError('Connexion impossible', error.message || 'Email ou mot de passe incorrect');
    }
  });

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <BrandMark />
          <h1 className="font-serif text-3xl text-ink mt-8">Connexion</h1>
          <p className="text-sm text-ink-muted mt-2">
            Pas encore de compte ?{' '}
            <Link to="/register" className="text-forest-700 hover:underline">
              Créer un compte
            </Link>
          </p>
        </div>
        <form onSubmit={handleSubmit} className="card p-6 space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-ink mb-1">
              Email
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
            />
          </div>
          <div>
            <div className="flex items-center justify-between mb-1">
              <label htmlFor="password" className="text-sm font-medium text-ink">
                Mot de passe
              </label>
              <Link to="/forgot-password" className="text-xs text-forest-700 hover:underline">
                Mot de passe oublié
              </Link>
            </div>
            <div className="relative">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input pr-10"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-faint"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </div>
          <LoadingButton type="submit" loading={isLoading('login')} loadingText="Connexion…" className="w-full" size="lg">
            Se connecter
          </LoadingButton>
        </form>
      </div>
    </div>
  );
};

export default Login;
